var path = 'areas/tenants/views/tenant_status_popover.html';
var html = "<i class=\"fa tenant-status\" ng-class=getIconStyle() uib-popover-template=\"'areas/tenants/views/tenant_status_popover_template.html'\" popover-trigger=mouseenter popover-placement=auto></i> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/views/tenant_status_popover.html
// module id = 1377152284465572
// module chunks = 1